export default {
  'releaseBillToReceive.list.header.code': 'Código',
  'releaseBillToReceive.list.header.installmentTag': 'Etiqueta',
  'releaseBillToReceive.list.header.companies': 'Empresa',
  'releaseBillToReceive.list.header.debtor': 'Devedor',
  'releaseBillToReceive.list.header.description': 'Descrição',
  'releaseBillToReceive.list.header.documentType': 'Tp.Doc.',
  'releaseBillToReceive.list.header.dueDate': 'Vencimento',
  'releaseBillToReceive.list.header.authorizationNumber':
    'Número de autorização',
  'releaseBillToReceive.list.header.situation': 'Situação',
  'releaseBillToReceive.list.header.value': 'Valor (R$)',
  'releaseBillToReceive.list.header.amountPaid': 'Valor pago',
  'releaseBillToReceive.list.header.actions': 'Ações',

  'releaseBillToReceiver.searchBar.create': 'Criar Nova Conta a Receber',
  'releaseBillToReceiver.searchBar.settleInstallments':
    'Liquidar Parcelas Selecionadas',

  'release.form.company': 'Empresa',
  'release.form.debtor': 'Devedor',
  'release.form.customer': 'Cliente',
  'release.form.insurer': 'Seguradora',
  'release.form.planAccount': 'Plano de Contas',
  'release.form.description': 'Descrição',
  'release.form.documentNumber': 'Número do Documento',
  'release.form.split': 'Parcela',
  'release.form.documentType': 'Tipo de Documento',
  'release.form.issueDate': 'Dt. Emissão',
  'release.form.dueDate': 'Dt. Vencimento',
  'release.form.payDay': 'Dt. Pagamento',
  'release.form.costCenter': 'Centro de Custo',
  'release.form.bankAccount': 'Conta Bancária',
  'release.form.value': '(R$) Valor',
  'release.form.increaseAndDecrease': '(R$) Acresc./Desc.',
  'release.form.increase': '(R$) Acréscimo',
  'release.form.discount': '(R$) Desconto',
  'release.form.netValue': '(R$) Valor Líquido',
  'release.form.observation': 'Observação',
};
